import parse from "html-react-parser";
function Event({ history, data }) {

  const goLink = (event) => {
    const { id } = event;
    history.push('/eventdetail?e_seq=' + id);
  };

  return (
    <>
      <div
        className="event-card col-4"
        onClick={() => {
          goLink({ id: data.e_seq });
        }}
      >
        {parse(data.e_image)}
        <p className="event-card__title">{data.e_title}</p>
        <p className="event-card__date">{data.e_date}</p>
      </div>
    </>
  );
}

export default Event;
